export default function ActiveUsers ({ users, hiddenNavItem }) {
  // Ordenar usuarios según tus reglas:
  // - Primero el más activo de los que sigues
  // - Luego el más popular
  // - Luego el resto activos
  const sortedUsers = [
    ...users
      .filter(u => u.followed) // Los que sigues
      .sort((a, b) => b.activityScore - a.activityScore)
      .slice(0, 1),
    ...users
      .sort((a, b) => b.popularity - a.popularity)
      .filter(u => !u.followed) // Populares no seguidos
      .slice(0, 1),
    ...users.filter(u => u.active && !u.followed) // Resto activos
  ];

  return (
    <div className={`relative w-full backdrop-blur-md rounded-2xl p-2 text-white shadow-lg`}>
      <div className="absolute w-full h-full bg-aw-bluedark/60"></div>
      <span className="absolute rounded-2xl bg-yellow-500 italic font-semibold text-[10px] text-aw-bgbluedark top-2.5 right-3.5 px-1 py-0.5">Pronto</span>
      <h2 className={`text-sm font-semibold mb-3 ${hiddenNavItem ? 'sm:flex' : 'hidden'}`}>Perfiles Activos</h2>
      <div className="space-y-2 h-[40dvh] sm:h-[41dvh] xl:max-h-[39dvh] 2xl:max-h-[40dvh] overflow-y-auto pr-1 scrollbar-box thin">
        {sortedUsers.map((user, idx) => (
          <div
            key={`${user.id}-${idx}`}
            className={`flex items-center justify-between ${hiddenNavItem ? 'p-2':'p-1'} rounded-xl transition-colors hover:bg-aw-green-15 duration-150 cursor-pointer ${
              idx === 0
                ? "bg-white/10"
                : idx === 1
                ? "bg-white/5"
                : ""
            }`}
          >
            {/* Imagen */}
            <div className="flex items-center gap-3">
              <img
                src={user.avatar}
                alt={user.name}
                className="w-8 h-8 rounded-full object-cover"
              />
              <div className={`flex flex-col leading-tight ${hiddenNavItem ? 'sm:flex' : 'hidden'}`}>
                <p className="text-[0.75rem] font-medium line-clamp-1">{user.name}</p>
                <p className="text-[0.65rem] text-gray-300">{user.role}</p>
              </div>
            </div>
            {/* Tiempo */}
            <span className={`text-xs text-gray-400 ${hiddenNavItem ? '' : 'hidden'}`}>{user.time}min</span>
          </div>
        ))}
      </div>
      {/* Footer */}
      <div className={`flex items-center justify-between mt-4 ${hiddenNavItem ? 'sm:flex' : 'hidden'}`}>
        <p className="text-xs text-gray-400">{users.length.toLocaleString()} Activos</p>
        <button className="text-xs font-medium text-white bg-white/10 hover:bg-white/20 px-3 py-1 rounded-lg transition">
          Ver más
        </button>
      </div>
    </div>
  );
};